/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Попап заказа услуги
   */
  app.ServiceOrderPopupView = app.View.extend({
    el: '.js-service-order-popup',

    run: function () {
      this._initConfirmationPopup();
      this.listenTo(Backbone, 'service-checkout:proceed', this.show);
    },

    /**
     * Инициализация попапа с формой оформления услуги.
     * @private
     */
    _initServiceForm: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#service-order-popup-template');
      this.render();
      this.initAlsPopup();
      this.childViews.formView = new app.ServiceOrderFormView({ 'el': this.$('.content-container') });
    },

    /**
     * Инициализация попапа подтверждения оплаты.
     * @private
     */
    _initConfirmationPopup: function () {
      this.serviceData = app.helpers.UrlHelper.getUrlParameters();

      if (this.serviceData.order && this.serviceData.payment) {
        this.childViews.paymentConfirmationPopupView = new app.PaymentConfirmationPopupView({
          orderId: this.serviceData.order,
          paymentId: this.serviceData.payment,
        });
      }
    },

    /**
     * Показать попап.
     * Установливает позицию, показывает оверлей
     * @param item : app.Item модель товара для отображения в попапе
     */
    show: function (item) {
      if (!this.childViews.formView) {
        this._initServiceForm();
      }

      if (item instanceof app.Item){
        this.childViews.formView.updateItem(item);

        var doc = $(document);
        this.$el.css({
          left: doc.width()/2 - this.$el.width()/2,
          top: doc.scrollTop() + 50,
          'z-index': 102
        });

        this.toggleOverlay();
        setTimeout(this.popup.open.bind(this.popup), 0);
      } else {
        if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
          Raven.captureException('Service item is not a instance of app.Item');
        }
      }
    },

    /**
     * Инициализация лебевского попапа. При закрытии скрывает оверлей
     */
    initAlsPopup: function () {
      var that = this;

      this.popup = new als.Popup(that.$el, that.$('.js-popup-close'));
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_CLOSE,
        that.toggleOverlay.bind(that)
      );
    },

    /**
     * Скрыть/показать оверлей
     */
    toggleOverlay: function () {
      app.fader.toggle();
    },

    /** @inheritDoc */
    render: function () {
      this.$el.html(this.template());
    },
  });
})(jQuery);

}.call(window));